export const AUTH_USER = "auth_user";
export const UNAUTH_USER = "unauth_user";
export const AUTH_FAILURE = "auth_failure";
export const USER_SUCCESS = "user_success";
export const DEFAULT_GROUP = "DEFAULT_GROUP";
